import React, { useState } from "react"
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover"
import { Calendar } from "./ui/calendar"
import { Button } from "./ui/button"
import { cn } from "src/lib/utils"
import { CalendarIcon } from "lucide-react"
import { formatDate } from "src/modules/convert"
import { DayPicker } from "react-day-picker"

const OFFSET = 60 * 60 * 9 * 1000

type Props = {
  value?: string
  onChange: (date?: string) => void
  className?: string
  calenderProps?: Omit<React.ComponentProps<typeof DayPicker>, "mode" | "selected" | "onSelect">
}

export default function DatePicker({ value, onChange, className, calenderProps }: Props) {
  const [open, setOpen] = useState(false)
  // JSTに変換
  const handleSelect = (d?: Date) => {
    if (!d) {
      return
    }
    const fixed = new Date(d.getTime() + OFFSET)
    onChange(formatDate(fixed.getTime() / 1000))
  }

  const handleOpen = (event: React.MouseEvent) => {
    event.preventDefault()
    setOpen(true)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger>
        <Button
          onClick={handleOpen}
          variant={"outline"}
          className={cn(
            "w-[280px] justify-start text-left font-normal",
            !value && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon />
          {value ? value : <span>日付を選択</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          defaultMonth={value ? new Date(value) : new Date()}
          selected={value ? new Date(value) : undefined}
          onSelect={handleSelect}
          numberOfMonths={1}
          {...calenderProps}
        />
      </PopoverContent>
    </Popover>
  )
}
